(function () {
    'use strict';
    angular.module('wamasysApp').factory('TicketMarkdownCodec', function () {
        function escaped(text) { return text.replace(/([\\`*_{}\[\]<>#])/g, '\\$1'); }
        function inline(node) { return Array.prototype.map.call(node.childNodes, read).join(''); }
        function read(node) {
            if (node.nodeType === 3) { return escaped(node.nodeValue.replace(/\u00a0/g, ' ')); }
            if (node.nodeType !== 1) { return ''; }
            var tag = node.tagName.toLowerCase(), content = inline(node);
            if (/^(script|style|iframe|object|svg|form|input|button)$/.test(tag)) { return ''; }
            if (tag === 'br') { return '\n'; }
            if (tag === 'b' || tag === 'strong') { return '**' + content + '**'; }
            if (tag === 'i' || tag === 'em') { return '*' + content + '*'; }
            if (tag === 'code' && node.parentNode.tagName.toLowerCase() !== 'pre') { return '`' + node.textContent.replace(/`/g, '') + '`'; }
            if (tag === 'pre') { return '\n\n```\n' + node.textContent.replace(/```/g, '~~~') + '\n```\n\n'; }
            if (/^h[1-6]$/.test(tag)) { return '\n\n' + new Array(Number(tag[1]) + 1).join('#') + ' ' + content.trim() + '\n\n'; }
            if (tag === 'blockquote') { return '\n\n' + content.trim().split('\n').map(function (line) { return '> ' + line; }).join('\n') + '\n\n'; }
            if (tag === 'a') {
                var href = node.getAttribute('href') || '';
                return /^(https?:\/\/|mailto:)/i.test(href) ? '[' + content + '](' + href.replace(/[()\s]/g, encodeURIComponent) + ')' : content;
            }
            if (tag === 'img') {
                var id = node.getAttribute('data-ticket-image'), src = node.getAttribute('src') || '', match = /^\/?api\/native-tickets\/images\/(\d+)$/.exec(src);
                if (!id && match) { id = match[1]; }
                return id && /^\d+$/.test(id) ? '![' + escaped(node.getAttribute('alt') || 'Image') + '](/api/native-tickets/images/' + id + ')' : '';
            }
            if (tag === 'ul' || tag === 'ol') {
                var index = 0;
                return '\n\n' + Array.prototype.filter.call(node.children, function (child) { return child.tagName.toLowerCase() === 'li'; }).map(function (child) {
                    index++; var value = inline(child).trim();
                    return (tag === 'ol' ? index + '. ' : '- ') + value.replace(/\n/g, '\n    ');
                }).join('\n') + '\n\n';
            }
            if (tag === 'table') {
                var rows = Array.prototype.map.call(node.querySelectorAll('tr'), function (row) { return Array.prototype.map.call(row.children, function (cell) { return inline(cell).trim().replace(/\|/g, '\\|').replace(/\n/g, ' '); }); });
                if (!rows.length) { return ''; }
                rows.splice(1, 0, rows[0].map(function () { return '---'; }));
                return '\n\n' + rows.map(function (row) { return '| ' + row.join(' | ') + ' |'; }).join('\n') + '\n\n';
            }
            if (tag === 'p' || tag === 'div') { return '\n\n' + content + '\n\n'; }
            if (tag === 'hr') { return '\n\n---\n\n'; }
            return content;
        }
        function fromHtml(html) {
            var document = new DOMParser().parseFromString(html, 'text/html');
            return inline(document.body).replace(/\n{3,}/g, '\n\n').trim();
        }
        return {fromHtml: fromHtml};
    });
    // Les images privées passent par $http pour bénéficier de l’authentification Wama.
    angular.module('wamasysApp').directive('ticketImages', ['$http', function ($http) {
        return {restrict: 'A', link: function (scope, element) {
            var urls = [], stopped = false;
            function load() {
                Array.prototype.forEach.call(element[0].querySelectorAll('img'), function (img) {
                    var match = /^\/?api\/native-tickets\/images\/(\d+)$/.exec(img.getAttribute('src') || '');
                    if (!match || img.getAttribute('data-image-loading')) { return; }
                    img.setAttribute('data-ticket-image', match[1]); img.setAttribute('data-image-loading', 'true');
                    $http.get('api/native-tickets/images/' + match[1], {responseType: 'blob'}).then(function (response) {
                        if (stopped) { return; } var url = URL.createObjectURL(response.data); urls.push(url); img.src = url;
                    }, function () { if (!stopped) { img.removeAttribute('src'); img.alt = 'Image indisponible ou accès refusé'; } });
                });
            }
            var observer = new MutationObserver(load); observer.observe(element[0], {childList: true, subtree: true}); load();
            scope.$on('$destroy', function () { stopped = true; observer.disconnect(); urls.forEach(function (url) { URL.revokeObjectURL(url); }); });
        }};
    }]);
})();
